import { config } from "config";

export function pushToDataLayer(
  event: TRACKING_EVENT_TYPE,
  data?: Record<string, unknown>
) {
  // @ts-ignore
  if (window[config.gtm.dataLayerName]) {
    // @ts-ignore
    window[config.gtm.dataLayerName].push({
      event,
      ...data,
    });
  }
}

export enum TRACKING_EVENT_TYPE {
  DefaultClick = "gtm.click",
  SaveBasicInfoForm = "save-basic-info-form",
  ChangeEthAndHer = "eh-change",
  ChangeSeekingRep = "seeking-rep-change",
  AddAvailabilityDates = "add-availability-dates",
  SubmitContactPerformerForm = "submit-contact-performer-form",
}

export enum TRACKING_VALUES {
  SeekingRepYes = "yes",
}
